import * as React from 'react';

import { Loading } from '@coursera/coursera-ui';

import 'css!./__style__/LoadingIcon';

class LoadingIcon extends React.Component {
  render() {
    return <Loading />;
  }
}

export default LoadingIcon;
